import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { getRequestWithToken } from "../../utils/ApiRequests";
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import { Box, Button, Chip, Container, Grid, Typography } from '@mui/material';
import { GlobalContext } from '../../components/GlobalStateProvide/GlobalStateProvider';
import "./employer.scss";
import BackBtn from '../../components/backButton/BackBtn';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';


import { checkPermission } from "../../utils/userPermissions";
import Unauthorized from "../../components/unauthorized/Unauthorized";

const EmployerDetails = () => {
  const { employerId } = useParams();
  const [searchParams] = useSearchParams();
  const u = searchParams.get("u");
  const [employerData, setEmployerData] = useState([]);
  const [employerTransactionsData, setEmployerTransactionsData] = useState([]);
  const [employerPostedJobsData, setEmployerPostedJobsData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const { handleSnackBar } = useContext(GlobalContext);
  const location = useLocation();

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);

  const [columnFilters2, setColumnFilters2] = useState([]);
  const [globalFilter2, setGlobalFilter2] = useState("");
  const [sorting2, setSorting2] = useState([]);
  const [isRefetching2, setIsRefetching2] = useState(false);
  const [isError2, setIsError2] = useState(false);

  const [rowCount, setRowCount] = useState(0);
  const [rowCount2, setRowCount2] = useState(0);
  const [loadingDataInTranxTable, setLoadingDataInTranxTable] = useState(null);
  const [loadingDataInJobsTable, setLoadingDataInJobsTable] = useState(null);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pagination2, setPagination2] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [canCreate, setCanCreate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRead, setCanRead] = useState(false);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(null);

  const columns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowIndex = row.index;
        return <span>{rowIndex + 1 + pageIndex * pageSize}</span>;
      },
    },
    { accessorKey: "merchantTransactionId", size: 250, header: "Transaction ID" },
    { accessorKey: "merchantId", size: 170, header: "Merchant ID" },
    {
      accessorKey: "paymentDate", size: 220, header: "Transaction Date",
      enableColumnFilter: false,
      Cell: ({ cell }) => (cell.getValue() ?
        <span>
          {new Date(cell.getValue()).toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
          })}
        </span> : '--'
      ),
    },
    { accessorKey: "planType", header: "Transaction Type", enableColumnFilter: false, },
    { accessorKey: "paymentMode", size: 180, header: "Mode of Payment", enableColumnFilter: false, },
    { accessorKey: "amount", size: 150, header: "Amount", enableColumnFilter: false, },
    { accessorKey: "creditType", size: 120, header: "Type", enableColumnFilter: false, },
    { accessorKey: "creditCount", size: 150, header: "Credits", enableColumnFilter: false, },
    { accessorKey: "state", header: "Payment Status", enableColumnFilter: false, },
    { accessorKey: "comment", header: "Reason", enableColumnFilter: false, },
    { accessorKey: "systemMessage", header: "System Message", enableColumnFilter: false, },
    {
      accessorKey: "doewnloadInvoice",
      header: "Action",
      size: 200,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <div style={{ textTransform: "uppercase" }}>
          {row?.original?.invoiceLink && <Button style={{ textTransform: "capitalize" }} onClick={() => handleDownloadInvoice(row?.original?.invoiceLink)}>View/Download Invoice</Button>}
        </div>
      ),
    },
  ];

  const handleDownloadInvoice = (invoiceLink) => {
    if (invoiceLink) {
      window.open(invoiceLink, '_blank');
    } else {
      handleSnackBar(true, "Invoice link not available", "error");
    }
  };


  const jobDataColumns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowIndex = row.index;
        return <span>{rowIndex + 1 + pageIndex * pageSize}</span>;
      },
    },
    {
      accessorKey: "jobId",
      header: "Job ID",
      Cell: ({ row }) => (
        <a
          href={`/posted-jobs/${row?.original?._id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
          style={{ cursor: canRead ? 'pointer' : 'not-allowed' }}
          onClick={(e) => !canRead && e.preventDefault()}
        >
          {row.original.jobId}
        </a>
      ),
    },
    { accessorKey: "jobRoleNameEn", id: 'jobRole', header: "Job Role" },
    {
      accessorKey: "jobLiveAt",
      enableColumnFilter: false,
      Cell: ({ cell }) => (cell.getValue() ?
        <span>
          {new Date(cell.getValue()).toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
          })}
        </span> : '--'
      ), header: "Date Posted"
    },
    {
      accessorKey: "city",
      header: "Location",
      enableColumnFilter: false,
      accessorFn: (row) => {
        let { city, state } = row.jobDescription?.jobLocation || {};
        return (
          [city, state].filter(Boolean).join(", ")
        )
        // row.jobDescription?.jobLocation.state ?? "---"},
      }
    },
    {
      accessorKey: "status",
      enableColumnFilter: false,
      accessorFn: (row) => {
        if (row?.deleted?.isDeleted) return "Deleted";
        if (row?.isArchived) return "Archived";
        if (row?.isDraft) return "Draft";
        if (row?.isActive) return "Active";
        if (row?.isAdminApprovalNeed) return "Admin Approval Needed";
        if (row?.isRejectedByAdmin) return "Rejected By Admin";
        return "Unknown";
      },
      header: "Status"
    },
  ];

  const getEmployerDetails = async () => {
    try {
      let response = await getRequestWithToken(`admin/userbyid?usertype=employer&userid=${employerId}`);
      setEmployerData(response.data.data);
      // console.log("response : " + JSON.stringify(response.data.data))
      setShowLoader(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setShowLoader(false);
    }
  };

  const getEmployerTransactionsDetails = async () => {
    setLoadingDataInTranxTable(true);
    try {

      const filterParams = {
        // global: globalFilter,
        ...Object.fromEntries(
          columnFilters.map((filter) => [filter.id, filter.value])
        ),
      };
      const filterQueryString = new URLSearchParams(filterParams).toString();

      let response = await getRequestWithToken(`admin/employer/transaction?page=${pagination.pageIndex + 1}&limit=${pagination.pageSize}&employerId=${employerId}&${filterQueryString}`);
      setEmployerTransactionsData(response.data.data);
      setRowCount(response?.data?.totalCount);
      // console.log("response : " + JSON.stringify(response.data.data))
      setLoadingDataInTranxTable(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setLoadingDataInTranxTable(false);
    }
  };

  const getEmployerPostedJobsDetails = async () => {
    setLoadingDataInJobsTable(true);
    try {

      const filterParams = {
        // global: globalFilter,
        ...Object.fromEntries(
          columnFilters2.map((filter) => [filter.id, filter.value])
        ),
      };
      const filterQueryString2 = new URLSearchParams(filterParams).toString();

      let response = await getRequestWithToken(`admin/employer/jobs?page=${pagination2.pageIndex + 1}&limit=${pagination2.pageSize}&employerId=${employerId}&${filterQueryString2}`);
      setEmployerPostedJobsData(response.data.data);
      setRowCount2(response?.data?.totalCount);
      // console.log("response : " + JSON.stringify(response.data.data))
      setLoadingDataInJobsTable(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setLoadingDataInJobsTable(false);
    }
  };

  useEffect(() => {

    getEmployerDetails();
  }, [employerId
  ]);


  useEffect(() => {
    getEmployerTransactionsDetails();
  }, [employerId,
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  useEffect(() => {
    getEmployerPostedJobsDetails();
  }, [employerId,
    columnFilters2,
    globalFilter2,
    pagination2.pageIndex,
    pagination2.pageSize,
    sorting2,
  ]);



  useEffect(() => {
    // console.log("data response: ", JSON.stringify(employerData));
  }, [employerData]);

  const table = useMaterialReactTable({
    columns,
    data: employerTransactionsData,

    initialState: { showColumnFilters: false },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    // enableColumnFilters: false,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      style: {
        backgroundColor: "#ff671f", // Custom orange color
      },
    },
    muiCircularProgressProps: {
      color: "secondary",
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading: loadingDataInTranxTable,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount / pageSize);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    renderTopToolbarCustomActions: ({ table }) => {
      const pinnedColumns = table.getState().columnPinning;
      return (
        <Box>
          <Chip
            label={`Left Pinned: ${pinnedColumns.left.length}`}
            color="primary"
            sx={{ mr: 1 }}
          />
          <Chip
            label={`Right Pinned: ${pinnedColumns.right.length}`}
            color="secondary"
          />
        </Box>
      );
    },
  });


  const jobTable = useMaterialReactTable({
    columns: jobDataColumns,
    data: employerPostedJobsData,

    initialState: { showColumnFilters: false },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    enableColumnFilters: true,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      style: {
        backgroundColor: "#ff671f", // Custom orange color
      },
    },
    muiCircularProgressProps: {
      color: "secondary",
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters2,
    onGlobalFilterChange: setGlobalFilter2,
    onPaginationChange: setPagination2,
    onSortingChange: setSorting2,
    rowCount: rowCount2,
    state: {
      columnFilters2,
      globalFilter2,
      isLoading: loadingDataInJobsTable,
      pagination: pagination2,
      showAlertBanner: isError2,
      showProgressBars: isRefetching2,
      sorting2,
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount2 / pageSize);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    // renderTopToolbarCustomActions: ({ table }) => {
    //   const pinnedColumns = table.getState().columnPinning;
    //   return (
    //     <Box>
    //       <Chip
    //         label={`Left Pinned: ${pinnedColumns.left.length}`}
    //         color="primary"
    //         sx={{ mr: 1 }}
    //       />
    //       <Chip
    //         label={`Right Pinned: ${pinnedColumns.right.length}`}
    //         color="secondary"
    //       />
    //     </Box>
    //   );
    // },
  });

  const checkPermissionFunc = () => {
    const resourceToUpdate = u === "employer" ? "Employer" : "Recruiter";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    const checkAccesInArray = localStorage.getItem("resourceNames");
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes(u === "employer" ? "Employer" : "Recruiter"));
  };

  useEffect(() => {
    // getAllJobs();
    checkPermissionFunc();
    againCheckPermissions();
  }, [isIncludesValue]);

  return isIncludesValue ? (
    (showLoader) ? <ReusableLoader /> :
      <Box className="create-candidates-section">

        <Container>

          <Box className="create-candidates">
            <Box className="headingPlusBackBtn">
              {/* <BackBtn /> */}
              <h1 className='formHeadings' style={{ textTransform: 'capitalize' }} id="topEle" >{u} Details</h1>
            </Box>
            <Box className="create-candidates-form-wrapper">

              <Box>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography variant="h7" component="h4">Personal Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="backgroundStyle">
                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>
                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'> First Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.firstName ? employerData?.firstName : '--'}</Typography>
                            </Box>
                          </Grid>

                          {/* <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'> Middle Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.middleName ? employerData?.middleName : '--'}</Typography>
                            </Box>
                          </Grid> */}

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >Last Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.lastName ? employerData?.lastName : '--'}</Typography>
                            </Box>
                          </Grid>

                        </Grid>
                      </Box>

                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>
                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'>Mobile Number</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.phone ? employerData?.phone : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'>Email Address</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.email ? employerData?.email : '--'}</Typography>
                            </Box>
                          </Grid>

                        </Grid>
                      </Box>

                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'  >Company Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.companyName ? employerData?.companyName : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' > Address</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.fullAddress ? employerData?.companyAddress?.fullAddress : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' > Pincode</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.pincode ? employerData?.companyAddress?.pincode : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >City</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.city ? employerData?.companyAddress?.city : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >State</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.state ? employerData?.companyAddress?.state : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >Recruitment Agency</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.recruitmentAgency ? "Yes" : 'No'}</Typography>
                            </Box>
                          </Grid>
                        </Grid>

                        {employerData?.businessLogo && <Grid container spacing={2} className='cstmFormGridEmployer' style={{ marginTop: '5px' }}>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >BusinessLogo</Typography>
                              {/* <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.state}</Typography> */}
                              <img src={employerData?.businessLogo} width={250} style={{ borderRadius: "10px" }} alt="" />
                            </Box>
                          </Grid>

                        </Grid>}
                      </Box>
                    </Box>

                    <Box className="backgroundStyle">
                      <Grid container spacing={2} className='cstmFormGridEmployer'>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <Typography variant="h7" component='h5'> PHC</Typography>
                            <Typography variant="subtitle2" style={{ paddingLeft: "5px", backgroundColor: "#e1f5fe", color: "#0277bd", fontWeight: "600" }} >{employerData?.plusHiringCredits?.availablePHC ? employerData?.plusHiringCredits?.availablePHC : '--'}</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <Typography variant="h7" component='h5'> HC</Typography>
                            <Typography variant="subtitle2" style={{ paddingLeft: "5px", backgroundColor: "#f3e5f5", color: "#6a1b9a", fontWeight: "600" }} >{employerData?.hiringCredits?.remainingHiringCredit ? employerData?.hiringCredits?.remainingHiringCredit : '--'}</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h7" component="h4">Transaction Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>

                    <MaterialReactTable
                      table={table}
                    />
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h7" component="h4">Posted Jobs Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MaterialReactTable
                      table={jobTable}
                    />
                  </AccordionDetails>
                </Accordion>

                {/* SNF Section - Search History */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-snf-search-content"
                    id="panel-snf-search-header"
                  >
                    <Typography variant="h7" component="h4">SNF - Search History</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ p: 2 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Recent search queries and activity (Demo Data)
                      </Typography>
                      <Grid container spacing={2}>
                        {[
                          { query: "Security Guard in Mumbai", filters: "Experience: 2+ years", date: "2026-02-23 14:30", results: 45 },
                          { query: "Warehouse Worker", filters: "Location: Andheri, Mumbai", date: "2026-02-22 16:45", results: 32 },
                          { query: "Delivery Driver", filters: "License: Valid, City: Mumbai", date: "2026-02-22 10:15", results: 28 },
                          { query: "Software Developer", filters: "Skills: React, Node.js", date: "2026-02-21 11:20", results: 18 },
                          { query: "Security Guard", filters: "Shift: Night", date: "2026-02-20 15:30", results: 52 }
                        ].map((item, index) => (
                          <Grid item xs={12} key={index}>
                            <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                              <Typography variant="subtitle2"><strong>{item.query}</strong></Typography>
                              <Typography variant="body2" color="text.secondary">Filters: {item.filters}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {item.date} | Results: {item.results}
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                {/* SNF Section - Session-wise Data */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-snf-session-content"
                    id="panel-snf-session-header"
                  >
                    <Typography variant="h7" component="h4">SNF - Session-wise Data</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ p: 2 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Detailed session activity and engagement (Demo Data)
                      </Typography>
                      <Grid container spacing={2}>
                        {[
                          { sessionId: "SES-20260223-001", date: "2026-02-23 14:25:30", searches: 8, viewed: 25, purchased: 5 },
                          { sessionId: "SES-20260222-002", date: "2026-02-22 16:40:15", searches: 5, viewed: 18, purchased: 3 },
                          { sessionId: "SES-20260222-001", date: "2026-02-22 10:10:45", searches: 3, viewed: 12, purchased: 2 },
                          { sessionId: "SES-20260221-001", date: "2026-02-21 11:15:20", searches: 6, viewed: 20, purchased: 4 },
                          { sessionId: "SES-20260220-001", date: "2026-02-20 15:25:10", searches: 7, viewed: 22, purchased: 0 }
                        ].map((item, index) => (
                          <Grid item xs={12} md={6} key={index}>
                            <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                              <Typography variant="subtitle2"><strong>{item.sessionId}</strong></Typography>
                              <Typography variant="body2">Date: {item.date}</Typography>
                              <Typography variant="body2">Searches: {item.searches} | Viewed: {item.viewed} | Purchased: {item.purchased}</Typography>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                {/* SNF Section - Purchase History */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-snf-purchase-content"
                    id="panel-snf-purchase-header"
                  >
                    <Typography variant="h7" component="h4">SNF - Purchase History</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ p: 2 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Candidate data purchase transactions (Demo Data)
                      </Typography>
                      <Grid container spacing={2}>
                        {[
                          { date: "2026-02-23", count: 5, category: "Security Guard", amount: 2500, status: "Completed" },
                          { date: "2026-02-22", count: 3, category: "Warehouse Worker", amount: 1500, status: "Completed" },
                          { date: "2026-02-22", count: 2, category: "Delivery Driver", amount: 1000, status: "Completed" },
                          { date: "2026-02-21", count: 4, category: "Software Developer", amount: 3200, status: "Completed" },
                          { date: "2026-02-19", count: 6, category: "Security Guard", amount: 3000, status: "Completed" }
                        ].map((item, index) => (
                          <Grid item xs={12} md={6} key={index}>
                            <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="subtitle2"><strong>{item.date}</strong></Typography>
                                <Chip label={item.status} color="success" size="small" />
                              </Box>
                              <Typography variant="body2">Category: {item.category}</Typography>
                              <Typography variant="body2">Candidates: {item.count} | Amount: ₹{item.amount.toLocaleString()}</Typography>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>

            </Box>
          </Box>
        </Container>

      </Box >) : <Unauthorized />;
};

export default EmployerDetails;
